// extracted by mini-css-extract-plugin
export default {"searchByDateContainer":"systemHistorySearchByDate_searchByDateContainer__NIB5Y"};